import { render, staticRenderFns } from "./FormSwitches.vue?vue&type=template&id=4e82f84c&"
import script from "./FormSwitches.vue?vue&type=script&lang=js&"
export * from "./FormSwitches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports